"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var InputText = function (_a) {
    var placeholder = _a.placeholder, labelText = _a.labelText, isDisabled = _a.isDisabled, hasError = _a.hasError, tooltip = _a.tooltip, helpertext = _a.helpertext, withPaste = _a.withPaste, withClear = _a.withClear, innerRef = _a.innerRef, _b = _a.hasPlaceholder, hasPlaceholder = _b === void 0 ? false : _b, _c = _a.errorTextCentered, errorTextCentered = _c === void 0 ? false : _c, _d = _a.errorWhenEmpty, errorWhenEmpty = _d === void 0 ? false : _d, props = __rest(_a, ["placeholder", "labelText", "isDisabled", "hasError", "tooltip", "helpertext", "withPaste", "withClear", "innerRef", "hasPlaceholder", "errorTextCentered", "errorWhenEmpty"]);
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.inputWrapper },
        react_1.default.createElement("input", __assign({ ref: innerRef, className: "".concat(styles_module_scss_1.default.input, " ").concat((helpertext === null || helpertext === void 0 ? void 0 : helpertext.status) === 'error' || (errorWhenEmpty && !props.value)
                ? styles_module_scss_1.default.error
                : '') }, props, { placeholder: !isDisabled || hasPlaceholder ? placeholder : '', disabled: isDisabled })),
        withClear && props.value && !isDisabled && (react_1.default.createElement("div", { onClick: function () { return props.onChange({ target: { value: '' } }); }, className: styles_module_scss_1.default.withClear }, t('clear'))),
        withPaste && !props.value && !isDisabled && (react_1.default.createElement("div", { onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                var text;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, navigator.clipboard.readText()];
                        case 1:
                            text = _a.sent();
                            props.onChange({ target: { value: text } });
                            return [2 /*return*/];
                    }
                });
            }); }, className: styles_module_scss_1.default.withPaste }, t('paste'))),
        (helpertext === null || helpertext === void 0 ? void 0 : helpertext.status) === 'error' && (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.errorText, " ").concat(errorTextCentered ? styles_module_scss_1.default.errorTextCentered : '') }, helpertext.text))));
};
exports.default = InputText;
